import { SaveListButton } from "components/entities/save_components/lists/SaveListButton";
import { useAllSuppliersSaved } from "lib/hooks/api/signals/useAllSuppliersSaved";
import { EventData } from "lib/tracking";

type Props = {
  supplierGuids: string[];
  trackingData?: EventData;
  /** Drops the "Save" label where the row is tight, such as a notice preview property row. */
  iconOnly?: boolean;
};

/**
 * Opens the save-to-list drawer for one or more suppliers, and fills the bookmark once they
 * are saved, so the button shows the current state rather than only offering the action.
 */
export function SaveSupplierButton({ supplierGuids, trackingData, iconOnly }: Props) {
  const { allSaved, isLoading } = useAllSuppliersSaved(supplierGuids);

  return (
    <SaveListButton
      entityIds={supplierGuids}
      entityType="supplier"
      trackingData={trackingData}
      buttonProps={{
        buttonType: "secondary",
        buttonText: iconOnly ? null : undefined,
        icon: {
          icon: "bookmark",
          // Secondary buttons already colour the icon sysPrimaryDefault, so filling with the
          // same token gives a solid blue bookmark rather than a two-tone one.
          fill: isLoading || !allSaved ? "transparent" : "sysPrimaryDefault",
        },
      }}
    />
  );
}

export default SaveSupplierButton;
